import { pick } from 'lodash/fp';
import { SavedColDef } from '../../store';
import { isStringField } from '../../utils';
import { CustomGridColDef } from './types';

export const storeColMapper = (gridColumns: Array<SavedColDef | CustomGridColDef>): SavedColDef[] =>
  gridColumns
    .filter((col) => 'headerName' in col && col.headerName && col.headerName.trim() !== '')
    .map(pick(['field', 'width', 'minWidth', 'isHidden', 'pinned']))
    .filter((col): col is SavedColDef => isStringField(col.field));
